import { Tooltip } from '@mui/material';
import AvalancheIcon from '../../../assets/images/Avalanche.webp';
import BUSDIcon from '../../../assets/images/BUSD.webp';
import FantomIcon from '../../../assets/images/Fantom.webp';
import FlowIcon from '../../../assets/images/Flow.webp';
import PolygonIcon from '../../../assets/images/Polygon.webp';
import SolanaIcon from '../../../assets/images/Solana.webp';
import SymbolIcon from '../../../assets/images/Symbol.webp';
import EthereumIcon from '../../../assets/images/Ethereum.svg';

import {
  SectionContainer,
  SectionHeading,
  IconContainer,
  Icon
} from './SupportedNetworks.style';

export const SupportedNetworks = () => {
  const icons = [
    {
      src: AvalancheIcon,
      title: 'Avalanche'
    },
    {
      src: BUSDIcon,
      title: 'Binance USD'
    },
    {
      src: EthereumIcon,
      title: 'Ethereum'
    },
    {
      src: FantomIcon,
      title: 'Fantom'
    },
    {
      src: FlowIcon,
      title: 'Flow'
    },
    {
      src: PolygonIcon,
      title: 'Polygon'
    },
    {
      src: SolanaIcon,
      title: 'Solana'
    },
    {
      src: SymbolIcon,
      title: 'Arbitrum'
    }
  ];

  return (
    <SectionContainer>
      <SectionHeading>Supported Networks</SectionHeading>
      <IconContainer>
        {icons.map((icon, idx) => {
          return (
            <Tooltip key={idx} title={icon.title} enterTouchDelay={0} arrow>
              <Icon src={icon.src} />
            </Tooltip>
          );
        })}
      </IconContainer>
    </SectionContainer>
  );
};
